import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import { COVERAGE_CATEGORIES } from "utils/api/graphql/queries/coverage-categories";
import { PROCESS } from "utils/api/graphql/queries/processes";
import { PROCESS_CONFIG_TYPES } from "utils/constants";
import Loader from "../Components/Loader";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const Needs = ({ project, onNext, onBack, currentStatus, tracer }) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("NEEDS", { returnObjects: true });
  const processId = get(tracer, "flow.process.id");

  const { data: categoriesData, loading: categoriesLoading } = useQuery(
    COVERAGE_CATEGORIES,
    {
      variables: { gt: { weight: 0 } },
    },
  );

  const { data: processData, loading: processLoading } = useQuery(PROCESS, {
    variables: { where: { id: processId } },
    skip: !processId,
  });

  const needsConfig = get(processData, "process.config", []).find(
    ({ type }) => type === PROCESS_CONFIG_TYPES.NEEDS,
  );

  const needsLevels = get(needsConfig, "value.needsLevels") || 5;
  const labels = get(needsConfig, "value.labels", {});
  const categoriesConfig = get(needsConfig, "value.categories", {});

  if (categoriesLoading || processLoading) return <Loader />;

  return (
    <>
      <Navbar project={project} currentStatus={currentStatus} tracer={tracer} />
      <View
        categories={get(categoriesData, "coverageCategories.data") || []}
        fields={get(project, "fields", {})}
        onNext={onNext}
        onBack={onBack}
        translate={TRANSLATION}
        needsLevels={needsLevels}
        labels={labels}
        categoriesConfig={categoriesConfig}
      />
    </>
  );
};

export default Needs;
